import { Stack } from "@mui/material";

const ScrollStack = ({ children, sx={}}) => {
  return (
    <Stack spacing={3} sx={{...sx}}>
      {children}
    </Stack>
  );
};

export default ScrollStack;
